import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src304228501/src/landing/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src304228501/src/landing/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src304228501/src/landing/src/components/AOSWrapper/AOSWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackToTopButton"] */ "/codebuild/output/src304228501/src/landing/src/components/BackToTopButton/BackToTopButton.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src304228501/src/landing/src/components/GlowCapture/GlowCapture.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src304228501/src/landing/src/components/Navigation/logo.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src304228501/src/landing/src/components/Navigation/Navigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteMain"] */ "/codebuild/output/src304228501/src/landing/src/components/WorldCupBanner/SiteMain.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BannerProvider","WorldCupBanner"] */ "/codebuild/output/src304228501/src/landing/src/components/WorldCupBanner/WorldCupBanner.tsx");
